import TextField from 'components/TextField';
import Form from 'components/Form';
import { Breadcrumb, BreadcrumbItem, Col, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import Button from 'components/Button';
import { withDragAndDropProvider } from 'contexts/dragAndDropProvider';
import Modal from 'components/Modal';
import { Loader } from 'react-bootstrap-typeahead';
import SelectField from 'components/SelectField';
import useControllerExternalNewsFormPage from 'pages/ExternalNews/ExternalNewsFormPage/_presenters/useControllerExternalNewsFormPage';
import AsyncTypeaheadField from 'components/AsyncTypeaheadField';
import NavCorporateTv from 'pages/CorporateTV/_presenters/enum/navCorporateTv';

const NewsFormPage = () => {
  const {
    formMethods,
    onSubmitHandler,
    handleOnDelete,
    isSaving,
    userCanPerformAction,
    userCanDelete,
    showDeleteConfirmation,
    setShowDeleteConfirmation,
    isFetching,
    externalNews,
    params,
    isDeleting,
    goOut,
    typeOptionsActive,
    categoriesOptions
  } = useControllerExternalNewsFormPage();

  return (
    <div className="mx-3">
      <Form onSubmit={onSubmitHandler} {...formMethods}>
        <Row className="d-flex align-items-center">
          <Col className="mb-3">
            <Breadcrumb className="mt-4">
              <BreadcrumbItem active>
                <Link
                  to={`/media-manager/corporate-tv?tab=${NavCorporateTv.EXTERNAL_NEWS}`}
                  className="text-decoration-none"
                >
                  Notícias externas
                </Link>
              </BreadcrumbItem>
              <BreadcrumbItem className="text-gray-600 fw-medium">
                {params.id ? externalNews?.name : 'Cadastrar notícia externa'}
              </BreadcrumbItem>
            </Breadcrumb>
            <h4 className="fw-bolder">
              {params.id ? externalNews?.name : 'Notícia externa'}
            </h4>
            <span className="small-typography text-gray-600">
              {params.id
                ? 'Realize a gestão das informações sobre a notícia externa cadastrada.'
                : 'Cadastre o conteúdo da sua notícia externa'}
            </span>
          </Col>
          <Col className="d-flex align-items-center justify-content-end">
            {userCanDelete && params.id && (
              <Button
                type="button"
                loading={isDeleting}
                className="button-outline delete me-2"
                onClick={() => setShowDeleteConfirmation(true)}
              >
                Excluir
              </Button>
            )}
            {!params.id && (
              <Button className="button-outline me-2" onClick={goOut}>
                Voltar
              </Button>
            )}
            {userCanPerformAction && (
              <Button
                type="submit"
                className="btn btn-primary text-white button-register"
                loading={isSaving}
                disabled={!formMethods.formState.isValid}
              >
                Salvar
              </Button>
            )}
          </Col>
        </Row>
        {isFetching ? (
          <Loader />
        ) : (
          <div>
            <div className="shadow bg-white form p-3 mt-3">
              <h5 className="text-gray-600 fw-bold">Informações Gerais</h5>
              <TextField
                label="Nome da notícia"
                name="name"
                placeholder="Digite um nome"
              />

              <AsyncTypeaheadField
                name="category"
                label="Categoria da notícia"
                options={categoriesOptions}
                placeholder="Selecione uma categoria"
                multiple={false}
              />

              <TextField
                label="Quantidade de notícias"
                name="quantityItems"
                type="number"
                placeholder="Digite a quantidade de noticías"
              />

              <SelectField
                name="isActive"
                label="Status"
                options={typeOptionsActive}
                defaultValue={String(externalNews?.isActive) || String(true)}
              />
            </div>
          </div>
        )}
      </Form>
      <Modal
        primaryButtonAction={handleOnDelete}
        primaryButtonLabel="Excluir"
        title="Atenção!"
        isOpen={showDeleteConfirmation}
        showCloseButton={false}
        toggle={() => setShowDeleteConfirmation((x) => !x)}
        secondaryButtonAction={() => setShowDeleteConfirmation(false)}
        secondaryButtonLabel="Cancelar"
      >
        <p>
          Deseja realmente excluir a notícia? <br />
          <small>Essa alteração não poderá ser revertida.</small>
        </p>
      </Modal>
    </div>
  );
};

export default withDragAndDropProvider(NewsFormPage);
